module.exports = __webpack_public_path__ + "assets/bubble-drill-f08a066ed39a12d9bcdefc85c56b4dcf.svg";


//////////////////
// WEBPACK FOOTER
// ./app/styles/assets/bubble-drill.svg
// module id = 103
// module chunks = 0